module.exports = "<div echarts [initOpts]=\"initOpts\" [options]=\"chartOption\" [style.width.px]=\"initOpts.width\" [style.height.px]=\"initOpts.height\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/parallel-coordinate-chart/parallel-coordinate-chart.component.html
// module id = ./src/app/shared/components/chart/parallel-coordinate-chart/parallel-coordinate-chart.component.html
// module chunks = main